import React from "react";

import { NOOP } from "core/constants";
import RoundQuantityButton from "core/Components/Buttons/QuantityButton/RoundQuantityButton";

type Props = {
    className?: string,
    inventoryPolicyIsContinue?: boolean,
    inventoryItemTracked?: boolean,
    inventoryQuantity?: number,
    quantity: number,
    maxQuantity: number,
    buttonSize?: number,
    onPlusIconClick: (e: React.MouseEvent) => void,
    onMinusIconClick: (e: React.MouseEvent) => void,
    onCustomQuantity: (quantity: React.ChangeEvent<HTMLInputElement>) => void,
    addToCartHandler?: () => void,
};

const QuantityPlusMinusButton: React.FC<Props> = (
    {
        className = '',
        quantity,
        maxQuantity,
        buttonSize = undefined,
        onPlusIconClick,
        onMinusIconClick,
        onCustomQuantity,
        addToCartHandler = NOOP,
    }
) => (
    <RoundQuantityButton
        className={className}
        quantity={quantity}
        maxQuantity={maxQuantity}
        minQuantity={1}
        buttonSize={buttonSize}
        plusClickHandler={onPlusIconClick}
        minusClickHandler={onMinusIconClick}
        onAddToCart={addToCartHandler}
        onChange={onCustomQuantity}
    />
);

export default QuantityPlusMinusButton;